<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<form novalidate>
  <div class="device-counter-wrapper" [ngClass]="setInputPosition()" [ngStyle]="{'opacity': disabled ? '0.5' : '1'}">
    <div id="devicesInputGroup" class="devices-input-group">
        <label *ngIf="labelPosition === 'left'" [ngStyle]="inputLabelStyles">{{label}}</label>
        <input id="quantityInputField" attr.aria-label="Number of {{label}}"
              [ngStyle]="inputStyles"
              data-lpignore="true"
              type="number"
              [step]="step"
              [max]="max"
              [min]="min"
              [(readonly)]="disabled"
              [(value)]="value"
              (input)="onValueChanged($event, $event.target.value)"
              (blur)="onValueChanged($event, $event.target.value)"
              name="quantity"
              class="quantity-field"
              required
              #inputValue>
        <label *ngIf="labelPosition === 'right'" [ngStyle]="inputLabelStyles">{{label}}</label>
    </div>
    <div class="input-group">
      <div *ngIf="showProgressBar" class="progress-bar-container">
        <div *ngIf="showMinMax" class="lower-limit" [ngStyle]="minLabelStyles">{{min}}</div>
        <div class="lower-limit-button">
          <input attr.aria-label="Decrease Number of {{label}}" type="button"
            data-lpignore="true"
            appThrottleClick
            value="-" 
            class="button-minus" 
            [(disabled)]="disabled"
            (throttleClick)="decrementValue()"
            [throttleTime]="200"
            (mousedown)="mousedownDecrement()"
            (mouseup)="mouseupDecrement()"
            (mouseleave)="mouseupDecrement()">
        </div>
        <mat-progress-bar class="progress-counter" mode="determinate" [value]="progressValue"></mat-progress-bar>
        <div class="higher-limit-button">
          <input attr.aria-label="Increase Number of {{label}}" type="button"
            data-lpignore="true"
            appThrottleClick
            value="+"
            class="button-plus"
            [(disabled)]="disabled"
            (throttleClick)="incrementValue()"
            [throttleTime]="200"
            (mousedown)="mousedownIncrement()"
            (mouseup)="mouseupIncrement()"
            (mouseleave)="mouseupIncrement()">
        </div>
        <div *ngIf="showMinMax" class="higher-limit" [ngStyle]="maxLabelStyles">{{max}}</div>
      </div>
    </div>
  </div>
</form>
